import { render, staticRenderFns } from "./approval_dialog.vue?vue&type=template&id=6456c48c"
import script from "./approval_dialog.vue?vue&type=script&lang=js"
export * from "./approval_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports